import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=4041072c&scoped=true"
import script from "./contactForm.vue?vue&type=script&lang=js"
export * from "./contactForm.vue?vue&type=script&lang=js"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=4041072c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041072c",
  null
  
)

export default component.exports